(function ($) {

	const maxTime = 500;
	const tick = 50;
	const maxTicks = maxTime / tick;

	function updateNumber(target) {
		let time = 0;

		const el$ = $(target);
		const number$ = el$.find('.number');
		const maxValue = +number$.data('max-value');
		const value = +number$.text();

		// console.log(number$.text());

		let delta = maxValue / maxTicks;
		if (delta < 1)
			delta = 1;
		const newValue = value + delta > maxValue ? maxValue : Math.trunc(value + delta);

		number$.text(newValue);

		if (newValue < maxValue)
			setTimeout(function () {
				updateNumber(target);
			}, tick);
	}

	function init() {
		const io = new IntersectionObserver((entries) => {
			for (const e of entries) {
				if (e.isIntersecting) {
					io.unobserve(e.target);
					updateNumber(e.target);
				}
			}
		}, {threshold: 0.15});

		document.querySelectorAll('.wp-block-roobs-counter').forEach(el => io.observe(el));
	}

	init();

}(jQuery))
